import { Store } from '@ngrx/store';
import * as fromApp from '../store';
import { AuthService } from './auth.service';
import * as i0 from "@angular/core";
import * as i1 from "./auth.service";
import * as i2 from "@ngrx/store";
export class AuthGuard {
    constructor(
    // private oauthService: OAuthService,
    authService, routerStore) {
        this.authService = authService;
        this.routerStore = routerStore;
    }
    canActivate() {
        return this.hasValidToken();
    }
    canLoad() {
        return this.hasValidToken();
    }
    hasValidToken() {
        // if (this.oauthService.hasValidAccessToken()) {
        if (this.authService.getAccessToken()) {
            return true;
        }
        this.routerStore.dispatch(new fromApp.Go({ path: [`/`] }));
        return false;
    }
}
AuthGuard.ngInjectableDef = i0.defineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.inject(i1.AuthService), i0.inject(i2.Store)); }, token: AuthGuard, providedIn: "root" });
